export const sellerDetailOrders = [
  {
    id: "ORD-8901",
    product: "Wireless Earbuds Pro",
    marketplace: "Amazon",
    qty: 2,
    amount: 2490,
    status: "Shipped",
    date: "2026-01-09",
  },
  {
    id: "ORD-8902",
    product: "USB-C Hub 7-in-1",
    marketplace: "Flipkart",
    qty: 1,
    amount: 1890,
    status: "Processing",
    date: "2026-01-09",
  },
  {
    id: "ORD-8903",
    product: "Laptop Stand Aluminum",
    marketplace: "Amazon",
    qty: 1,
    amount: 3450,
    status: "Delivered",
    date: "2026-01-08",
  },
  {
    id: "ORD-8904",
    product: "Mechanical Keyboard",
    marketplace: "Meesho",
    qty: 1,
    amount: 4200,
    status: "Shipped",
    date: "2026-01-08",
  },
  {
    id: "ORD-8905",
    product: "Phone Case Bundle x3",
    marketplace: "Amazon",
    qty: 3,
    amount: 890,
    status: "Processing",
    date: "2026-01-09",
  },
  {
    id: "ORD-8906",
    product: "Webcam 1080p",
    marketplace: "Flipkart",
    qty: 1,
    amount: 2100,
    status: "Returned",
    date: "2026-01-07",
  },
  {
    id: "ORD-8907",
    product: "Bluetooth Speaker",
    marketplace: "Amazon",
    qty: 1,
    amount: 1650,
    status: "Delivered",
    date: "2026-01-07",
  },
  {
    id: "ORD-8908",
    product: "Mouse Pad XL",
    marketplace: "Meesho",
    qty: 2,
    amount: 560,
    status: "Delivered",
    date: "2026-01-06",
  },
];
